export const PrepaymentMethods = {
  canpay: 'canpay',
  janePay: 'jane_pay',
  moneris: 'moneris',
  payfirma: 'payfirma',
  square: 'square',
  stronghold: 'stronghold',
} as const;

export type PrepaymentProviders =
  (typeof PrepaymentMethods)[keyof typeof PrepaymentMethods];

export interface Customer {
  authenticated?: boolean;
  birthDate: string;
  email: string;
  externalId: string;
  firstName: string;
  id: number | null;
  lastName: string;
  nickname: string;
  phone: string;
  promotionsOptOut?: boolean;
}

export interface PreAuthOptions {
  consents: number[] | null;
  deliveryMessage: string | null;
  fulfillmentTime: string | null;
  pickupMessage: string | null;
  pickupMode: 'pickup' | 'curbside' | null;
}

/** A guest's checkout form `customerInformation`, kept so it survives signing in. */
export interface PreAuthCustomer {
  birthDate?: string;
  email?: string;
  firstName?: string;
  governmentIdentificationUrl?: string;
  lastName?: string;
  mmjExpirationDate?: string;
  mmjIdBackUrl?: string;
  mmjIdFrontUrl?: string;
  mmjIdNumber?: string;
  phone?: string;
  promotionsOptOut?: boolean;
}

export type PreAuthSelection = PrepaymentProviders | 'janeGold' | null;

/** Router state carried into checkout after a guest signs in mid-checkout. */
export interface CheckoutLocationState {
  /** Set when a partner using `externalAuth` sends the shopper back into checkout. */
  externalAuthReturn?: boolean;
  preAuthCustomer?: PreAuthCustomer;
  preAuthOptions?: PreAuthOptions;
  preAuthSelection?: PreAuthSelection;
}
